import { useLocation } from "react-router";
import LightTooltip from "../common/LightTooltip";
import { useStateValue } from "../../context/StateValueContext";
import { useBrandId } from "../../hooks/useBrandId";
import { isBrandAwarePath } from "../../utils/brandAwarePaths";
import SearchableHeaderDropdown from "./SearchableHeaderDropdown";

const UNSUPPORTED_HINT = "This page shows company-level data.";

export default function BrandSelector() {
  const [{ brands }] = useStateValue();
  const { brandId: selectedBrandId, setBrandId } = useBrandId();
  const { pathname } = useLocation();

  if (brands.length < 2) {
    return null;
  }

  const brandAware = isBrandAwarePath(pathname);

  const dropdown = (
    <SearchableHeaderDropdown
      options={brands.map((brand) => ({ id: brand.brandId, label: brand.brandName }))}
      selectedId={selectedBrandId}
      onSelect={setBrandId}
      allLabel="All Brands"
      searchPlaceholder="Search brands..."
      emptyMessage="No brands found"
      widthClass="w-[220px]"
      disabled={!brandAware}
      icon={
        <svg
          className="w-4 h-4 flex-shrink-0 text-gray-500 dark:text-gray-400"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M7 7h.01M7 3h5a1.99 1.99 0 011.414.586l7 7a2 2 0 010 2.828l-5 5a2 2 0 01-2.828 0l-7-7A1.99 1.99 0 013 10V5a2 2 0 012-2z"
          />
        </svg>
      }
    />
  );

  if (!brandAware) {
    return (
      <LightTooltip title={UNSUPPORTED_HINT}>
        <span>{dropdown}</span>
      </LightTooltip>
    );
  }

  return dropdown;
}
